import _ from "underscore";

import React from "react";
import { store as OverlayStore } from "../../utils/overlay-store";

class OverlayController extends React.Component {
  static displayName = "OverlayController";
  state = { overlays: OverlayStore.getAll() };

  componentDidMount() {
    OverlayStore.onChange(this.onChange);
  }

  componentWillUnmount() {
    OverlayStore.clearOnChange(this.onChange);
  }

  onChange = () => {
    this.setState({ overlays: OverlayStore.getAll() });
  };

  render() {
    if (this.state.overlays) {
      return (
        <div>
          {_.map(this.state.overlays, overlay => {
            return (
              <div
                key={overlay.key}
                style={{
                  position: "fixed",
                  top: overlay.position != null ? overlay.position.top : undefined,
                  left: overlay.position != null ? overlay.position.left : undefined,
                  bottom: overlay.position != null ? overlay.position.bottom : undefined,
                  right: overlay.position != null ? overlay.position.right : undefined,
                  zIndex: overlay.position.zIndex,
                }}
              >
                {overlay.component}
              </div>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  }
}
export default OverlayController;
